module.exports = __webpack_public_path__ + "img/paquete-vivaaerobus.e0a1d1a9.jpg";